import { useNavigate } from 'react-router-dom';
import { VideoUploader } from '../components/VideoUploader';

export function UploadFile() {
  const navigate = useNavigate();

  const handleUploadSuccess = (entryId: string) => {
    navigate(`/entry/${entryId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-3xl font-bold text-gray-900">Upload File</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8 text-center">
          <p className="text-gray-600">
            Upload a previously recorded audio or video file.
          </p>
        </div>

        <VideoUploader
          onUploadComplete={handleUploadSuccess}
          onError={(error) => {
            console.error('Upload error:', error);
            alert(error.message);
          }}
        />

        <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <h3 className="text-sm font-semibold text-blue-900 mb-2">Tips</h3>
          <ul className="text-sm text-blue-800 space-y-1 list-disc list-inside">
            <li>Supported formats: MP3, WAV, M4A, OGG, WebM (audio) and MOV, MP4, AVI, MKV (video)</li>
            <li>Maximum file size: 500MB</li>
            <li>Your media will be automatically transcribed after upload</li>
          </ul>
        </div>
      </main>
    </div>
  );
}
